import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ObjectTreeState } from './state'

export const selectObjectTree = createFeatureSelector<ObjectTreeState>('objectTree')

export const selectTree = createSelector(
  selectObjectTree,
  tree => tree.tree
)

export const selectItems = createSelector(
  selectObjectTree,
  tree => tree.items
)

export const selectSelectedItems = createSelector(
  selectObjectTree,
  tree => tree?.selectedItems
)

// get distinct itemNames as one string
export const selectSelectedItemNames = createSelector(
  selectSelectedItems,
  items => [...new Map(items.map(item => [item.itemId, item])).values()].map(i => i.item.name).join(', ')
)


export const selectSelectedItemIds = createSelector(
  selectSelectedItems,
  items => items.map(i => i.itemId)
)

export const selectObjectTreeErrors = createSelector(
  selectObjectTree,
  tree => tree?.errors
)
